var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cate-tips-wrapper",class:{'disabled': _vm.disabled}},_vm._l((_vm.tips),function(tip,index){return _c('div',{key:index,staticClass:"cate-tip"},[_c('i',{class:tip.icon || 'icon-filled_special_r'}),_c('span',{staticClass:"content"},[_vm._v(_vm._s(tip.content + (_vm.moretext ? ', ' + _vm.moretext : '')))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }